module.exports = __webpack_public_path__ + "static/media/Technologyicon02@3x.b1dcd3f3.png";